import { BaseTextMergeEditor } from "../BaseTextMergeEditor";
import { TextMergeEditContext } from "../../../rule-engine-core/TextMerge/TextMergeEditContext";
import React from "react";
import { Box } from "@mui/material";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import { HorizontalLineElement } from "../../../rule-engine-core/TextMerge/Elements/Text/HorizontalLineElement";
import { BaseTextMergeElement } from "../../../rule-engine-core/TextMerge/Elements/BaseTextMergeElement";

export class TextMergeHorizontalLineEditor extends BaseTextMergeEditor<HorizontalLineElement> {
    renderDisplay(_config: BaseTextMergeElement, _editContext: TextMergeEditContext): React.ReactNode {
        return <hr></hr>;
    }

    renderEditor(config: BaseTextMergeElement, editContext: TextMergeEditContext): React.ReactNode {
        return (
            <Box
                padding={"3px"}
                margin={"3px"}
                bgcolor={"white"}
                border={editContext.selectedElement?.id === config.id ? "2px solid red" : "1px solid blue"}
                onClick={() => {
                    editContext.setSelectedElement(config);
                }}
            >
                <>Horizontal Line</>
            </Box>
        );
    }

    getIcon(): JSX.Element {
        return <HorizontalRuleIcon />;
    }
}
